<ng-template #lastCustomizationModal let-modal>
  <div class="modal-content">
    <div class="modal-header border-bottom">
      <h4 class="modal-title">{{ "heading-title.repeat-last-customization" | translate }}?</h4>
      <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
  </div>
  <div class="modal-body">
    <div class="flex-column d-flex gap-2">
      @for(variant of cartItemVariants; track $index) {
      <div class="d-flex gap-1 justify-content-between">
        <div>
          <div class="d-flex align-items-center gap-2">
            <h4>{{ selectedProduct.name | translate }}</h4>
            <span class="fs-6 mb-2 text-muted">( {{ getVariantName(variant.variantId) }} )</span>
          </div>
          <div class="d-flex ms-1 align-items-center">
            <span class="current-price">
              {{ getPriceOfCustomizedVariant(variant).toFixed(helper.adminSettings?.decimalPointValue) }}
            </span>
            <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
              {{ helper.currencySign }}
            </span>
          </div>
          <div>
            @if(variant.modifiers && variant.modifiers.length > 0){
            <span class="text-muted">
              {{ formatModifiers(variant) | translate }}
            </span>
            }
          </div>
        </div>
        <div class="d-flex align-items-center flex-column">
          <div class="d-flex align-items-center gap-3 button" [ngStyle]="gridChildViewConfig && gridChildViewConfig.button ? getButtonStyle(gridChildViewConfig.button) : null">
            <button
              class="icon-button"
              (click)="decrementProductQuantity(variant, $index)"
              [ngStyle]="{
                color: gridChildViewConfig && gridChildViewConfig.button ? gridChildViewConfig.button.color : ''
              }"
            >
              <i class="ri-subtract-line ri-lg"></i>
            </button>
            <span
              [ngStyle]="{
                color: gridChildViewConfig && gridChildViewConfig.button ? gridChildViewConfig.button.color : '#fff'
              }"
            >
              {{ getTotalProductVariantQty(variant) }}
            </span>
            <button
              class="icon-button"
              (click)="incrementProductQuantity(variant)"
              [ngStyle]="{
                color: gridChildViewConfig && gridChildViewConfig.button ? gridChildViewConfig.button.color : ''
              }"
              [disabled]="getTotalProductVariantQtyinCart(variant.variantId) === getVariantMaxQtyAddInCart(variant.variantId)"
            >
              <i class="ri-add-line ri-lg"></i>
            </button>
          </div>
          <div class="d-flex ms-1 align-items-center">
            <span class="fw-semibold">
              {{ getTotalProductVariantPrice(variant).toFixed(helper.adminSettings?.decimalPointValue) }}
            </span>
            <span [ngClass]="{ 'order-first': helper.adminSettings?.setCurrencySign == helper.SetCurrencySignUnit.LEFT }" class="fw-semibold">
              {{ helper.currencySign }}
            </span>
          </div>
        </div>
      </div>
      }
    </div>
    <button class="btn btn-dark w-100 mt-3" (click)="openCustomizationModal()">{{ "button-title.add-new-customization" | translate }}</button>
  </div>
</ng-template>
